import { Component, OnInit, EventEmitter, Output, ViewContainerRef, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { FormHelperService } from "../core/services";
import { DropdownValue } from "../shared/dropdown.model";
import { IPublisherSettingsModel } from "./publisher.model";
import { CustomValidators } from "ng2-validation";

@Component({
    selector: 'publisher-settings-modal-form',
    moduleId: module.id,
    templateUrl: 'publisher-settings-modal-form.component.html'
})

export class PublisherSettingsFormComponent implements OnInit {
    publisherSettingsForm: FormGroup;
    deviceTypeValues: Array<DropdownValue> = [];
    sectionOpen: boolean = true;
    deviceWasSelected: boolean = false;
    deviceTypePrefix: string = "Device Type"

    //contains the device type of the mapping that needs to be removed from the parent
    @Output()
    public removedPublisherSetting: EventEmitter<number> = new EventEmitter<number>();

    constructor(
        private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        public viewContainerRef: ViewContainerRef, 
        private elRef: ElementRef) { }

    ngOnInit(): void {
        this.publisherSettingsForm = this.formBuilder.group({
            urlField: ['', [Validators.required, CustomValidators.url]],
            versionField: ['', []],
            bundleIdField: ['', []],
            showCreditNotificationField: ['', []],
            isRefundingCreditField: ['', []],
            deviceTypeField: ['', [Validators.required]]
        });
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.publisherSettingsForm, controlName, validator)
    }

    onDeviceTypeValueChanged(item) {
        this.publisherSettingsForm.controls["deviceTypeField"].setValue(item.value);
        this.deviceWasSelected = true;
    }

    removeSection() {
        this.removedPublisherSetting.emit(this.publisherSettingsForm.value.deviceTypeField);
    }

    toggleSection() {
        event.preventDefault();
        this.sectionOpen = !this.sectionOpen;

        var svgButton = $(this.elRef.nativeElement.querySelector('.ctrl-collapse')).find("svg");
        $(svgButton).toggleClass("turned");
    }
}


// WEBPACK FOOTER //
// ./src/app/publishers/publisher-settings-modal-form.component.ts